<template>
  <transition>
    <div
      v-if="filterToggle"
      class="pt-2"
    >
      <b-form
        class="border-dashed"
      >
        <b-row>
          <b-col
            md="6"
          >
            <b-form-group
              :label="$t('Education organizations')"
              :label-for="ResearchAdvisor.ORGANIZATION"
            >
              <v-select
                :id="ResearchAdvisor.ORGANIZATION"
                v-model="filters[ResearchAdvisor.ORGANIZATION]"
                :reduce="(option) => option.id"
                :options="universityList"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
                @input="onFilter()"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </transition>
</template>

<script>
import vSelect from 'vue-select'
import {
  BButton, BCol, BForm, BFormGroup, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { isObject } from '@core/utils/utils'
import store from '@/store'
import ResearchAdvisor from '@/views/components/filters/service/ResearchAdvisor'

export default {
  name: 'FilterComponent',
  components: {
    BForm,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    filterToggle: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: [Array, Object],
      default: () => ({}),
    },
    filterClass: {
      type: [Object, null],
      default: null,
    },
    selectedFilters: {
      type: [Array],
      default: () => ([]),
    },
  },
  data() {
    return {
      period: null,
    }
  },
  computed: {
    ResearchAdvisor() {
      return ResearchAdvisor
    },
    universityList() {
      return this.$store.state.staticModule.universityList
    },
  },
  watch: {
    universityList(newValue) {
      this.changeValue(newValue, ResearchAdvisor.ORGANIZATION)
    },
  },
  created() {

  },
  methods: {
    onFilter() {
      this.$emit('onFilter', this.filter)
    },
    changeValue(newValue, field) {
      if (newValue.length && !isObject(this.filters[field])) {
        this.filters[field] = newValue.find(x => `${x.id}` === this.filters[field])
      }
    },
  },
  setup() {
    const studentStatues = store.getters['staticModule/getStudentStatuses']()
    return {
      studentStatues,
    }
  },
}
</script>

<style scoped>

</style>
